import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { FormGroup, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';
import { environment } from "../../../environments/environment";
import { CmsService } from 'src/app/Services/cms.service';
import { ExternalService } from 'src/app/Services/external.service';

declare var bootstrap: any;

@Component({
    selector: 'app-homepage',
    templateUrl: './homepage.component.html',
    standalone: false
})
export class HomepageComponent implements OnInit, AfterViewInit{
  images = [
    "assets/img/hero-img-1.jpg",
    "assets/img/hero-img-2.jpg",
    "assets/img/hero-img-3.jpg",
  ];

  heroSlides: number = 0;
  carouselIntervalOriginal: number = 5000;
  carouselInterval: number = 5000;

  language: string = '';
  defaultLanguage: string = environment.defaultLanguage;

  home_content: string = 'linhas-home-page';
  homeInfo: any = {};

  news_content_name: string = 'linhas-news-list';
  newsReady: number = 0;
  newsList: any[] = [];
  newsListSize: number = 0;

  warnings_content_name: string = 'linhas-avisos-alertas';
  warningsReady: number = 0;
  warningsList: any[] = [];
  warningsListShow: any[] = [];
  warningsListSize: number = 0;

  municipalities: any[] = [];
  lines: any[] = []

  searchForm: FormGroup = new FormGroup({
    municipality: new FormControl(''),
    line: new FormControl('')
  });

  constructor(
    config: NgbCarouselConfig,
    private externalService: ExternalService,
    private cmsService: CmsService,
    private route: ActivatedRoute,
    private router: Router,
    private translate: TranslateService,
    private title: Title
  ) {
    // customize default values of carousels used by this component tree
    config.interval = this.carouselIntervalOriginal;
    config.wrap = true;
    config.keyboard = false;
    config.pauseOnHover = false;
    config.pauseOnFocus = true;

    let lang = localStorage.getItem('language') ?? this.defaultLanguage;
    this.language = lang.split('-')[0];

    this.title.setTitle('Linhas | Transportes do Douro, Tâmega e Sousa');
  }

  ngOnInit() {
    this.getHome()
    this.getNews()
    this.getWarnings()
    this.getMunicipalities()
    this.onChanges()
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.route.fragment.subscribe(fragment => {
        if (fragment) {
          const targetElement = document.getElementById(fragment);
          if (targetElement) {
            targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }
      });
    }, 500);
  }

  getHome(){

    this.cmsService.getContentList(this.home_content, this.language).subscribe(
      {
        next: data => {
          this.homeInfo = data['body']['data']

          this.heroSlides = Math.max(this.homeInfo.Slide.length, this.homeInfo.Slide_Imagens.length);

        },
        error: er => {
          this.router.navigate(['/500']);
        }
      }
    );
  }

  getNews(){
    this.newsReady = 0;
    this.newsList = [];
    this.cmsService.getContentList(this.news_content_name, this.language).subscribe(
      {
        next: data => {
          this.newsList = data['body']['data'];

          this.newsList.forEach(element => {
            let date = new Date(element.Data)
            element.formattedDate = Intl.DateTimeFormat(this.language, { day: 'numeric', month: 'long', year: 'numeric' }).format(date);
          });

          this.newsList.sort((a,b) => (a.Data > b.Data) ? -1 : 1 );

          this.newsListSize = this.newsList.length;

          this.newsList = this.newsList.slice(0,3)

          this.newsReady = 1;

        },
        error: er => {
          this.router.navigate(['/500']);
        }
      }
    );
  }

  goToNews(id: string){
    this.router.navigate(['/noticias-detalhe'], { queryParams: { id: id } });
  }

  getWarnings(){
    this.warningsReady = 0;
    this.warningsList = [];
    this.cmsService.getContentList(this.warnings_content_name, this.language).subscribe(
      {
        next: data => {

          let today = new Date()

          let list = data['body']['data'];

          let filteredList: any[] = []

          list.forEach((element: any) => {
            const startDate = new Date(element.Inicio);
            const endDate = new Date(element.Fim != null ? element.Fim : 4133894400000);
            endDate.setHours(23, 59, 59, 999);

            if(today >= startDate && today <= endDate){
              element.municipalities_string = element.Municipios.map((item: any) => item.Municipio).join(", "),
              filteredList.push(element)
            };

            let date = new Date(element.Inicio)
            element.formattedDate = Intl.DateTimeFormat(this.language, { day: 'numeric', month: 'long', year: 'numeric' }).format(date);


          });

          filteredList.sort((a, b) => (a.Inicio > b.Inicio) ? -1 : 1 );

          this.warningsListSize = filteredList.length;

          this.warningsList = Object.values(
            filteredList.reduce((acc, item) => {
                  if (!acc[item.Inicio]) {
                      acc[item.Inicio] = { Inicio: item.Inicio, formattedDate: item.formattedDate, Avisos: [] };
                  }
                  acc[item.Inicio].Avisos.push(item);
                  return acc;
              }, {} as Record<string, { Inicio: string; formattedDate: string; Avisos: { Inicio: string; Titulo: string }[] }>)
          );

          this.warningsListShow = this.warningsList;

          this.warningsReady = 1;


        },
        error: er => {
          this.router.navigate(['/500']);
        }
      }
    );
  }

  getMunicipalities(){
    this.externalService.getMunicipalities().subscribe(
      {
        next: data => {

          this.municipalities.splice(0)
          
          data.forEach(element => {
            let mun = {
              name: element['pDescricao'],
              code: element['pDescricao'],
              key: element['pKey'],
              region: element['pNUTIII']
            }

            this.municipalities.push(mun)
          });

          this.municipalities = this.municipalities.sort((a: any, b: any) => a.name.localeCompare(b.name, 'pt', { sensitivity: 'base' }) );
        },
        error: er => {
        this.router.navigate(['/500']);
        } 
      })
  }

  onChanges(){
    this.searchForm.get('municipality')?.valueChanges.subscribe(
      val => {
        if(val != '') {
          let munCode = val.split('##')[0];

          this.searchForm.get('line')?.setValue('')

          this.warningsListShow = this.warningsList
            .map(item => ({
              ...item,
              Avisos: item.Avisos.filter((warning: any) =>
                warning.Municipios.some((mun: any) => mun.Municipio.toUpperCase() === munCode.toUpperCase())
              )
            }))
            .filter(item => item.Avisos.length > 0)

          this.filerByMunicipality(munCode);
        } else {
          this.lines.splice(0)
          this.warningsListShow = this.warningsList;
        }
      }
    )

    this.searchForm.get('line')?.valueChanges.subscribe(
      val => {
        if(val != ''){
          let munName = this.searchForm.get('municipality')?.value.split('##')[1]
          this.warningsListShow = this.warningsList
            .map(item => ({
              ...item,
              Avisos: item.Avisos.filter((warning: any) =>
                warning.Municipios.some((mun: any) => mun.Municipio.toUpperCase() === munName.toUpperCase()) &&
                (warning.Linhas != null && warning.Linhas.includes(val))
              )
            }))
            .filter(item => item.Avisos.length > 0)
        } else {
          let munName = this.searchForm.get('municipality')?.value.split('##')[1]
          this.warningsListShow = this.warningsList
            .map(item => ({
              ...item,
              Avisos: item.Avisos.filter((warning: any) =>
                warning.Municipios.some((mun: any) => mun.Municipio.toUpperCase() === munName.toUpperCase())
              )
            }))
            .filter(item => item.Avisos.length > 0)
        }


      }
    )
  }

  filerByMunicipality(municipality: string){
    this.lines.splice(0);
    this.externalService.getRoutesByMunicipality(municipality).subscribe(
      {
        next: data => {
          data.forEach(item => {
            let line = {
              number: item['pCodCarOperador'],
              name: item['pDesignacao'],
              municipality: municipality,
              operator: item['pdesigOperador'],
              codeCIM: item['pCodCarCIM'],
              color: item['pColorHex']
            }

            this.lines.push(line);
          });
        },
        error: er => {
          this.router.navigate(['/500']);
        }
      }
    )
  }

  onVideoPlay() {
    this.carouselInterval = this.carouselIntervalOriginal; // stop auto sliding when video plays
  }

  onVideoPause() {
    this.carouselInterval = this.carouselIntervalOriginal; // restore interval
  }

  onVideoEnded() {
    this.carouselInterval = this.carouselIntervalOriginal; // resume auto slide when video ends
  }
}
